import { mapDTO } from '@twistezo/ts-dto-mapper'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'
import { WorkspaceDTO } from '..'
import { WorkspaceDomainDTO } from '../api/types/workspaceDTO'
import { Workspace, WorkspaceDomain } from '../types/workspace'
import { WorkspaceAlert } from '../types/workspaceAlert'
import { csManagerFromDTO } from './csManager'
import { dataSamplingFromDTO } from './dataSampling'
import { gamConnectionOrderFromDTO } from './gamConnectionOrderFromDTO'
import { gamSetupOrderFromDTO } from './gamSetupOrderFromDTO'

export const workspaceFromDTO = (from: WorkspaceDTO): Workspace =>
  mapDTO<WorkspaceDTO, Workspace>({ from }).transform((data: WorkspaceDTO): Workspace => {
    const {
      alerts,
      createdAt,
      csManager,
      domains,
      financeReportUrl,
      gamSetupOrder,
      latestGamConnectionOrder,
      performanceReportUrl,
      prebidManagerAccountId,
      prebidManagerSampling,
      primaryCurrency,
      updatedAt,
    } = data

    return {
      ...data,
      alerts: alertsFromDTO<WorkspaceAlert>(alerts),
      createdAt: new Date(createdAt),
      csManager: csManager ? csManagerFromDTO(csManager) : undefined,
      domains: domains ? domainsFromDTO(domains) : [],
      financeReportUrl: financeReportUrl ?? undefined,
      gamOrderRetargetingDealsDelivery: undefined, // not used globally
      gamSetupOrder: gamSetupOrder ? gamSetupOrderFromDTO(gamSetupOrder) : undefined,
      latestGamConnectionOrder: latestGamConnectionOrder
        ? gamConnectionOrderFromDTO(latestGamConnectionOrder)
        : undefined,
      performanceReportUrl: performanceReportUrl ?? undefined,
      prebidManagerAccountId: prebidManagerAccountId ?? undefined,
      prebidManagerSampling: dataSamplingFromDTO(prebidManagerSampling),
      primaryCurrency: primaryCurrency ?? undefined,
      updatedAt: new Date(updatedAt),
    }
  })

const domainsFromDTO = (from: WorkspaceDomainDTO[]): WorkspaceDomain[] => {
  return from.map(
    (domain: WorkspaceDomainDTO): WorkspaceDomain => ({
      ...domain,
      alerts: alertsFromDTO<DomainAlert>(domain.alerts),
    }),
  )
}
